import { render, staticRenderFns } from "./PriorityBar.vue?vue&type=template&id=2b777700&"
import script from "./PriorityBar.vue?vue&type=script&lang=js&"
export * from "./PriorityBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PriorityBar.vue"
export default component.exports